import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import styled from "styled-components";
import { useUtils } from "../../services/utilsProvider";
import { Icon } from "../../ui";
import DepartmentForm from "./DepartmentForm";
import { useDepartments } from "./provider";

const Grid = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  div {
    font-size: 20px;
    font-weight: bold;
    display: flex;
    align-items: center;
    line-height: 0;
    svg {
      margin: 0 20px 0 10px;
    }
  }
`;

function EditDepartment() {
  const params = useParams();
  const navigate = useNavigate();
  const { notify } = useUtils();

  const {
    state: { selected: department },
    fetchOne,
    dispatch,
  } = useDepartments();

  useEffect(() => {
    fetchOne(params.id);
  }, [fetchOne, dispatch, params.id]);

  const handleSuccess = () => {
    navigate(-1);
    notify("Changes saved successfully");
  };

  if(!department || department.id !== Number(params.id)) return;

  return (
    <div id="edit-department">
      <Grid>
        <h2 style={{ marginTop: "0" }}>Edit Department</h2>
        <div style={{ cursor: "pointer" }} onClick={() => navigate(-1)}>
          <span>Back</span>
          <Icon name="arrowLeft" />
        </div>
      </Grid>
      <DepartmentForm department={department} handleSuccess={handleSuccess} />
    </div>
  );
}

export default EditDepartment;
